export default "__VITE_ASSET__DfWDbrF9__"